export const InactivityTimerService = {
    timer: null as number | null,

    resetTimer: () => {
        if (InactivityTimerService.timer !== null) {
            clearTimeout(InactivityTimerService.timer);
            InactivityTimerService.timer = null;
        }
    },
    //TODO: Kuandinka logout au timeout logic ya ukweli
    refreshUserActivity: () => {
        InactivityTimerService.resetTimer();
        InactivityTimerService.timer = window.setTimeout(() => {
            console.log('User is inactive');
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/login";
        }, 360000); //FIXME: 30 Dakika ni uongo🌚
    },
};